import { PDP_LAYOUT_TYPE } from '@src/quince-site-common/src/domains/contentful/ContentfulProduct'
import { defaultDesktopConfig, defaultMobileConfig } from './configs/default.layout'
import { longFormDesktopConfig, longFormMobileConfig } from './configs/longform.layout'
import { giftCardDesktopConfig, giftCardMobileConfig } from './configs/giftcard.layout'
import { bundleDesktopConfig, bundleMobileConfig } from './configs/bundle.layout'
import { bundleLongFormDesktopConfig, bundleLongFormMobileConfig } from './configs/bundle-longform.layout'

export const LAYOUT_TYPE_VS_DESKTOP_CONTAINER_CONFIG = {
  [PDP_LAYOUT_TYPE.DEFAULT]: defaultDesktopConfig,
  [PDP_LAYOUT_TYPE.LONG_FORM]: longFormDesktopConfig,
  [PDP_LAYOUT_TYPE.GIFT_CARD]: giftCardDesktopConfig,
  [PDP_LAYOUT_TYPE.BUNDLE]: bundleDesktopConfig,
  [PDP_LAYOUT_TYPE.BUNDLE_LONG_FORM]: bundleLongFormDesktopConfig,
}

export const LAYOUT_TYPE_VS_MOBILE_CONTAINER_CONFIG = {
  [PDP_LAYOUT_TYPE.DEFAULT]: defaultMobileConfig,
  [PDP_LAYOUT_TYPE.LONG_FORM]: longFormMobileConfig,
  [PDP_LAYOUT_TYPE.GIFT_CARD]: giftCardMobileConfig,
  [PDP_LAYOUT_TYPE.BUNDLE]: bundleMobileConfig,
  [PDP_LAYOUT_TYPE.BUNDLE_LONG_FORM]: bundleLongFormMobileConfig,
}
